import { render, staticRenderFns } from "./packages.vue?vue&type=template&id=27e3b99b&"
import script from "./packages.vue?vue&type=script&lang=js&"
export * from "./packages.vue?vue&type=script&lang=js&"
import style0 from "./packages.vue?vue&type=style&index=0&id=27e3b99b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports